import { connect } from 'react-redux'
import Works from './works'
import {
  getFetchRequest,
  getWorksAssessmentFileStudent
} from '../../../../stores/works/works.selectors'
import {
  fetchAssessmentFileWorks,
  setMedia
} from '../../../../stores/works/works.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match }) => {
  const fetchRequest = getFetchRequest(state)
  const student = getWorksAssessmentFileStudent(state)
  return {
    id: match.params.assessmentFileId,
    student: student,
    pending: fetchRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: id => {
    dispatch(setMedia(0))
    return dispatch(fetchAssessmentFileWorks(id)).catch(errorHandler)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Works)
